<script>
// import Translations from "./insert-me-to-translate.vue";

import Recaptcha from './recaptcha';
import Hcaptcha from './hcaptcha';
import {mapGetters} from "vuex";
import sumBy from 'lodash/sumBy';
import values from 'lodash/values';

export default {
    props: ['initEmail', 'initEmailError', 'initPassword', 'initPasswordError', 'initTerms', 'initTermsError', 'initGeneralError'],
    components: {
        Recaptcha,
        Hcaptcha,
        UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
    },
    data: function(){
        return  {
            isPasswordVisible: false,
            password: this.initPassword,
            passwordError: this.initPasswordError,
            isRecaptchaFilled: true,
            generalError: this.initGeneralError || '',
            submittedForm: false,

        };
    },
    computed:{
        ...mapGetters({
            isRecaptchaReady: 'ui/recaptcha/isReady',
            recaptchaResponse: 'ui/recaptcha/response',
        }),        

        progressStatus() {
            const conditions = {
                length: this.password.length>=8,
                number: this.password.match(/\d/),
                lower: this.password.match(/[a-z]/),
                upper: this.password.match(/[A-Z]/),
            };

            const satisfiedCount = sumBy(values(conditions), c => {return c ? 1:0});
            conditions.progressClass = satisfiedCount > 0 ? `p${satisfiedCount*25}` : '';
            return conditions;
        },
    },
    methods: {
        onEyeClick: function(event){
            this.isPasswordVisible = !this.isPasswordVisible;
        },
        validate: function(event){

            this.passwordError = '';
            this.isRecaptchaFilled = !!this.recaptchaResponse;

            if(this.password.trim() && this.isRecaptchaFilled){
                this.submittedForm = true;
                return true;
            }else{
                if(!this.password.trim()){
                    this.passwordError = gettext('Please fill in this field');
                }else{
                    if(this.password.length < 8 || !this.password.match(/\d/) || !this.password.match(/[a-z]/) || !this.password.match(/[A-Z]/)){
                        this.passwordError = gettext('Password must be at least 8 characters long and must have at least one lowercase letter, one UPPERCASE letter and one number.')
                    }
                }

            }
            event.preventDefault();
        }
    }
};
</script>
